import React, { useEffect } from 'react'
import { InvestmentColTwoSpan,BodyText,  InvestmentColTwoSpanReverse, LeftColSection, LeftSection, RightColSection, RightSection, SavingsHeader, SavingsTextHeader, SavingsWrapper } from './SavingsStage.styles'

export const SavingsStage = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  
  return (
    <SavingsWrapper>
      <SavingsHeader>
            <LeftSection>
            <h3>
                Long term Savings designed for Kids, managed by the parents.
            </h3>
            <BodyText>
                This plan allows you save consistently for your kids as they grow from Infancy to Adulthood. 
            </BodyText>
            </LeftSection>
            <RightSection>
                <img src="img/pana.jpg" alt="couple saving in a bottle" />
            </RightSection>
        </SavingsHeader>
        <SavingsTextHeader>There are 2 stages of withdrawals for this savings plan.</SavingsTextHeader>

        <InvestmentColTwoSpanReverse>
        <LeftColSection>
        <h3>Elementary Stage</h3>

          <BodyText>
                At this stage, the child should have attained an age 
                between 9-11years, A Certain Target amount of Money is
                been saved on a monthly basis, Spans the Elementary education
                period i.e 132 months.

          </BodyText>
        </LeftColSection>
        <RightColSection>
            <img src="img/amico2.jpg" alt="humaan girl playing with pet" />
        </RightColSection>
      </InvestmentColTwoSpanReverse>
      <InvestmentColTwoSpan>
        <LeftColSection>
        <h3>High School Stage</h3>
          <BodyText>
                  At this Stage, The teenager should be in the final class
                  at High school, A Certain Target amount of money is been
                  saved on a monthly basis Spans the High school period i.e 72months.
          </BodyText>
          <BodyText>
                  At the end of the Savings period for each Stage an Equity 
                  Syndicate Investment will be made on behalf of the Child with the funds
          </BodyText>

        </LeftColSection>
        <RightColSection>
            <img src="img/amico3.jpg" alt="humaan boy saving coins in a bottle" />
        </RightColSection>
      </InvestmentColTwoSpan>

    </SavingsWrapper>
  )
}
